/* Copyright (C) Okahu Inc 2023-2024. All rights reserved. */
'use client';

import React from 'react';
import { useLanguage } from '@/providers/LanguageProvider';
import { formatApiDate } from '@/utils/formatedDates';

import { System } from '../icons';

export const MetricDetail = ({
  lastUpdated,
  lastMetric,
  showMetric,
}: {
  lastUpdated?: string | null;
  lastMetric?: string | null;
  showMetric?: boolean;
}) => {
  const { messages } = useLanguage();
  const generalIntl = messages?.General;

  return (
    <div className="flex w-full items-center gap-2 rounded-lg border border-line-tertiary bg-canvas-background-primary p-3">
      {System.InfoIcon('h-6 w-6 text-form-input-disabled')}
      <>
        {showMetric && (
          <p className="flex gap-1 text-form-input-text text-body-subtle">
            <span>{generalIntl?.last_metric_gathered_on} </span>
            <span>
              {lastMetric
                ? formatApiDate(lastMetric)
                : generalIntl?.not_available}
            </span>
          </p>
        )}

        <p className="flex gap-1 text-form-input-text text-body-subtle">
          <span>{generalIntl?.last_updated} </span>
          <span>
            {lastUpdated
              ? formatApiDate(lastUpdated)
              : generalIntl?.not_available}
          </span>
        </p>
      </>
    </div>
  );
};
